import { useEffect, useState } from "react";
import { getDownloadURL, ref as storageRef } from "firebase/storage";
import { storage } from "../../helpers/firebaseConfig";
import { podcastAudioPath } from "./podcastShare";

export default function useSharedPodcastAudio(builderId, runId) {
  const [state, setState] = useState({ url: "", loading: true, error: "" });

  useEffect(() => {
    if (!builderId || !runId || builderId.includes("/") || runId.includes("/")) {
      setState({ url: "", loading: false, error: "This podcast link is invalid." });
      return undefined;
    }

    let active = true;
    setState({ url: "", loading: true, error: "" });
    getDownloadURL(storageRef(storage, podcastAudioPath(builderId, runId)))
      .then((url) => { if (active) setState({ url, loading: false, error: "" }); })
      .catch((error) => {
        if (!active) return;
        const message = error?.code === "storage/object-not-found"
          ? "This podcast is not available yet. Please try again later."
          : "This podcast could not be opened. Please check the link or try again later.";
        setState({ url: "", loading: false, error: message });
      });
    return () => { active = false; };
  }, [builderId, runId]);

  return state;
}
